import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { CardBlock } from "@/puck/landing/cardBlock";

export const cardConfigs: Pick<LandingComponents, "Card"> = {
  Card: {
    label: "Feature card",
    fields: {
      title: { type: "text", contentEditable: true },
      description: { type: "textarea", contentEditable: true },
      background: {
        type: "select",
        label: "Background",
        options: [
          { label: "Voice card", value: "voiceCard" },
          { label: "Soft blue", value: "softBlue" },
          { label: "White", value: "white" },
          { label: "Surface", value: "surface" },
        ],
      },
      radius: {
        type: "select",
        label: "Corner radius",
        options: [
          { label: "XL", value: "xl" },
          { label: "2XL", value: "2xl" },
          { label: "3XL", value: "3xl" },
        ],
      },
      bordered: {
        type: "radio",
        label: "Border",
        options: [
          { label: "Show", value: true },
          { label: "None", value: false },
        ],
      },
      interactive: {
        type: "radio",
        label: "Hover lift",
        options: [
          { label: "On", value: true },
          { label: "Off", value: false },
        ],
      },
      visual: {
        type: "slot",
        label: "Visual",
        allow: ["ChatMockup", "ChartMockup", "PhoneVideo"],
      },
    },
    defaultProps: {
      title: "Ask anything",
      description:
        "Query your book in plain language — policies, claims, payments.",
      background: "voiceCard",
      radius: "2xl",
      bordered: true,
      interactive: true,
      visual: [],
    },
    render: CardBlock as import("@puckeditor/core").PuckComponent<
      import("@/puck/types").CardBlockProps & { anchor?: string }
    >,
  },
};
